const initialState = {
  fakeMessages: [],
  addFakeMessages: false,
  enableSendMessageButton: false,
  onlyImages: []
};

const messagesReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case 'SET_FAKE_MESSAGES': {
      return {
        ...state,
        fakeMessages: payload,
        addFakeMessages: true
      }
    }
    case 'EMPTY_FAKE_MESSAGES': {
      return {
        ...state,
        fakeMessages: [],
        addFakeMessages: false
      }
    }
    case 'ENABLE_SEND_MESSAGE_BUTTON': {
      return {
        ...state,
        enableSendMessageButton: true
      }
    }
    case 'DISABLE_SEND_MESSAGE_BUTTON': {
      return {
        ...state,
        enableSendMessageButton: false
      }
    }
    case 'ADD_ONLY_IMAGES': {
      const index = find(state.onlyImages, { url: payload.url });
      const newOnlyImages = [...state.onlyImages];

      if (!index) {
        newOnlyImages.push(payload);
      };

      return {
        ...state,
        onlyImages: newOnlyImages
      }
    }
    case 'EMPTY_ONLY_IMAGES': {
      return {
        ...state,
        onlyImages: []
      }
    }
    default:
      return state;
  }
};

export default messagesReducer;
